import React from 'react';
import IconButton from '@mui/material/IconButton';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useColorScheme } from '@mui/material';

function ModeSwitcher() {
    const { mode, setMode } = useColorScheme();

    if (!mode) {
        return null;
    }

    const handleToggle = () => {
        setMode(mode === 'light' ? 'dark' : 'light');
    };

    return (
        <IconButton onClick={handleToggle} color="inherit">
            {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
    );
}

export { ModeSwitcher };
export default React.memo(ModeSwitcher);
